// import storage from 'store'
// import { login, getInfo, logout, } from '@/api/loginOrUser/login'
// import { getCurrentUser } from '@/api/loginOrUser/user'

// import { ACCESS_TOKEN } from '@/store/mutation-types'
// import { welcome } from '@/utils/util'
const user = {
    state: {
        token: '',
        name: '',
        welcome: '',
        avatar: '',
        roles: [],
        info: {},
        quicknav: []
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, { name, welcome }) => {
            state.name = name
            state.welcome = welcome
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_INFO: (state, info) => {
            state.info = info
        },
        SET_QUICKNAV: (state, nav) => {
            state.quicknav = nav
        }
    },

    actions: {
        // 登录
        // Login({ commit }, userInfo) {
        //     return new Promise((resolve, reject) => {
        //             login(userInfo).then(response => {
        //                 if (response.body.data) {
        //                     const result = response.body.data
        //                     storage.set(ACCESS_TOKEN, result, 24 * 60 * 60 * 1000)
        //                     commit('SET_TOKEN', result)
        //                     resolve()
        //                 } else {
        //                     reject()
        //                 }
        //             }).catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        // 获取用户信息
        // GetInfo({ commit }) {
        //     return new Promise((resolve, reject) => {
        //         getCurrentUser().then(response => {
        //             const result = response.body.data
        //             commit('SET_INFO', result)
        //             commit('SET_NAME', { name: result.u_name })
        //             commit('SET_QUICKNAV', quicknav)
        //             resolve(response)
        //         }).catch(error => {
        //             reject(error)
        //         })
        //     })
        // },

        // 登出
        // Logout({ commit }) {
        //     return new Promise((resolve) => {
        //         commit('SET_TOKEN', '')
        //         storage.remove(ACCESS_TOKEN) //删除TOKEN
        //         resolve()
        //     })
        // }

    }
}

export default user
